import { debounce } from "lodash";
import React from "react";

function useScrollSpy(
  selectors: string[],
  offset: number = 0,
  elementId: string = "root"
) {
  const [activeId, setActiveId] = React.useState<string>("");
  const [scrollTop, setScrollTop] = React.useState<number>(0);

  const element = React.useMemo(() => {
    return document.getElementById(elementId);
  }, [elementId]);

  React.useEffect(() => {
    if (!element) return;

    const elements: any[] = selectors
      .map((selector) => document.querySelector(selector))
      .filter((x) => x);

    const onScroll = () => {
      if (!elements || elements?.length < 1) return;

      const scrollPosition = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const containerHeight = element.clientHeight;
      const isAtEnd =
        scrollHeight - Math.round(scrollPosition) === containerHeight;

      setScrollTop(scrollPosition);

      const inViewElements: string[] = [];

      if (!isAtEnd) {
        for (let element in elements) {
          const offsetTop = elements[element]?.offsetTop ?? 0;

          if (offsetTop <= scrollPosition + offset) {
            inViewElements.push(elements[element].id);
          }
        }
      } else {
        inViewElements.push(elements[elements.length - 1].id);
      }

      setActiveId(inViewElements[inViewElements.length - 1]);
    };

    const debouncedScroll = debounce(onScroll, 200);

    element.addEventListener("scroll", debouncedScroll);

    return () => {
      debouncedScroll.cancel();
      element.removeEventListener("scroll", debouncedScroll);
    };
  }, [scrollTop, selectors, offset, element]);

  return [activeId];
}

export default useScrollSpy;
